module.exports = __webpack_public_path__ + "static/media/13d.a3204d95.svg";